/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Footer, Header, Banner } from "./ui";;

const Layout = ({ location, children }) => {
  const data = useStaticQuery(graphql`
    query LayoutQuery {
      site {
        siteMetadata {
          title
          navigation {
            title
            link
            items {
              link
              text
            }
          }
        }
      }
      allFooter {
        nodes {
          footer {
            cards {
              description
              link
              linkText
              title
              hoverText
              id
            }
            linksNav {
              link
              linkText
              type
              externalIcon
            }
          }
        }
      }
    }
  `)

  const {site, allFooter } = data;
  const { title, navigation } = site.siteMetadata;
  const {linksNav, cards } = allFooter.nodes[0].footer;
  return (
    <>
      <a className="usa-skipnav" href="#main-content">
        Skip to main content
      </a>
      <Banner />
      <div className="usa-overlay" />
      <Header siteTitle={title} navigationLinks = {navigation} location={location}/>
        <a name="top"></a>
        {children}
      <Footer cards = {cards} linksNav = {linksNav} />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
